/* Clignote : page devis. Un clic sur une carte (logo, événement, revendeur, location) présélectionne le type dans le formulaire. */
(() => {
  const sel = document.getElementById('d-type');
  const cartes = [...document.querySelectorAll('[data-devis-type]')];
  if (!sel || !cartes.length) return;
  const choisir = type => {
    const opt = [...sel.options].find(o => o.dataset.type === type);
    if (opt) sel.value = opt.value;
    cartes.forEach(c => c.hasAttribute('aria-pressed') && c.setAttribute('aria-pressed', String(c.dataset.devisType === type)));
  };
  cartes.forEach(c => c.addEventListener('click', e => {
    e.preventDefault();
    choisir(c.dataset.devisType);
    document.getElementById('devis-form')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setTimeout(() => document.getElementById('d-qty')?.focus({ preventScroll: true }), 400);
  }));
  sel.addEventListener('change', () => choisir(sel.selectedOptions[0]?.dataset.type));
})();
